// extracted by mini-css-extract-plugin
export default {"container":"projects_container__tqwtf","h1":"projects_h1__vZNd+","p":"projects_p__kg5xG","cardBox":"projects_cardBox__b6uM3"};